import * as z from 'zod';

export const resourceConnection = z.object({
    id: z.string(),
    name: z.string(),
    resourceType: z.string(),
    room: z.string(),
    blocked: z.boolean(),
    vertices: z.array(z.array(z.number())),
    connected: z.boolean(),
});

export type ResourceConnection = z.infer<typeof resourceConnection>;
